import React from 'react';
import { SVGAttributes } from 'react';

export const ClipboardOutlineIcon: React.FC<SVGAttributes<never>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M15.4444 2.63636H12.1933C11.8667 1.68727 11.0111 1 10 1C8.98889 1 8.13333 1.68727 7.80667 2.63636H4.55556C3.7 2.63636 3 3.37273 3 4.27273V17.3636C3 18.2636 3.7 19 4.55556 19H15.4444C16.3 19 17 18.2636 17 17.3636V4.27273C17 3.37273 16.3 2.63636 15.4444 2.63636ZM10 2.63636C10.4278 2.63636 10.7778 3.00455 10.7778 3.45455C10.7778 3.90455 10.4278 4.27273 10 4.27273C9.57222 4.27273 9.22222 3.90455 9.22222 3.45455C9.22222 3.00455 9.57222 2.63636 10 2.63636ZM15.4444 17.3636H4.55556V4.27273H6.11111V6.72727H13.8889V4.27273H15.4444V17.3636Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ClipboardOutlineIcon;
